
























































import { Vue, Component, Prop } from "vue-property-decorator";
import { Factura } from "@/typings/store/plugins/easyFirestore/facturas";
import { NotaCreditoFactura } from "@/helpers/notasCredito";
import { aISOLocal } from "@/helpers/fechas";
import {
  DatosPago,
  MEDIOS_PAGO,
  PagoFactura,
  armarPago,
  saldoPorCobrar,
  totalNotasEmitidas,
  totalPagado,
  validarPago,
} from "@/helpers/pagosFacturas";

@Component
export default class PagoFacturaDialogo extends Vue {
  @Prop({ required: true }) readonly factura!: Factura;
  @Prop({ default: () => [] }) readonly notasCredito!: NotaCreditoFactura[];
  @Prop({ default: () => [] }) readonly pagos!: PagoFactura[];
  @Prop({ type: Boolean, default: false }) readonly cargando!: boolean;

  medios = MEDIOS_PAGO;
  datos: DatosPago = { fecha: "", monto: 0, medio: "Transferencia", banco: "", numeroOperacion: "", observacion: "" };
  error = "";

  created(): void {
    this.datos.fecha = aISOLocal(new Date());
    this.datos.monto = Math.max(0, this.saldo);
  }

  get notas(): number {
    return totalNotasEmitidas(this.notasCredito, this.factura.id);
  }

  get pagado(): number {
    return totalPagado(this.pagos, this.factura.id);
  }

  get saldo(): number {
    return saldoPorCobrar(this.factura, this.notasCredito, this.pagos);
  }

  moneda(v: number): string {
    return new Intl.NumberFormat("es-CL", { style: "currency", currency: "CLP" }).format(v || 0);
  }

  guardar(): void {
    this.error = validarPago(this.datos, this.saldo);
    if (this.error) return;
    this.$emit("guardar", { pago: armarPago(this.factura, this.datos) });
  }
}
